"use strict";

exports.__esModule = true;
exports.default = fallbackApi;
var _toArray = _interopRequireDefault(require("../../toArray.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// .files fallback, should be implemented in any browser
function fallbackApi(dataTransfer) {
  var files = (0, _toArray.default)(dataTransfer.files);
  return Promise.resolve(files);
}